import { useCallback, useRef, useState } from "react";

// Quản lý các hình dán đang có trên dải ảnh.
//
// Hình dán được chọn nhận diện bằng ID chứ không bằng chỉ số mảng — trước đây
// dùng chỉ số nên xoá một hình ở giữa là con trỏ chọn nhảy sang hình khác.
export function useStickers() {
    const [stickers, setStickers] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const idRef = useRef(0);

    const addSticker = useCallback(sticker => {
        idRef.current += 1;
        const id = idRef.current;
        setStickers(prev => [...prev, { ...sticker, id }]);
        setSelectedId(id);
        return id;
    }, []);

    const updateSticker = useCallback((id, patch) => {
        setStickers(prev => prev.map(s => (s.id === id ? { ...s, ...patch } : s)));
    }, []);

    const removeSticker = useCallback(id => {
        setStickers(prev => prev.filter(s => s.id !== id));
        setSelectedId(cur => (cur === id ? null : cur));
    }, []);

    const clearStickers = useCallback(() => {
        setStickers([]);
        setSelectedId(null);
    }, []);

    return {
        stickers,
        selectedStickerId: selectedId,
        selectSticker: setSelectedId,
        addSticker,
        updateSticker,
        removeSticker,
        clearStickers
    };
}

export default useStickers;
